module.exports = __webpack_public_path__ + "10_mole.7369ee6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer2/10_mole.png
// module id = mhNR
// module chunks = 0